var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.25,
    height: 21.25,
    viewBox: "0 0 21.25 21.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2825",
    "data-name": "Path 2825",
    d: "M8.19,0H1.549A1.551,1.551,0,0,0,0,1.549V5.534a1.551,1.551,0,0,0,1.549,1.55H8.19a1.551,1.551,0,0,0,1.55-1.55V1.549A1.551,1.551,0,0,0,8.19,0Zm0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2826",
    "data-name": "Path 2826",
    d: "M8.19,213.332H1.549A1.551,1.551,0,0,0,0,214.882v9.3a1.551,1.551,0,0,0,1.549,1.549H8.19a1.551,1.551,0,0,0,1.55-1.549v-9.3A1.551,1.551,0,0,0,8.19,213.332Zm0,0",
    transform: "translate(0 -204.478)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2827",
    "data-name": "Path 2827",
    d: "M285.522,341.332h-6.64a1.551,1.551,0,0,0-1.55,1.55v3.984a1.551,1.551,0,0,0,1.55,1.549h6.64a1.551,1.551,0,0,0,1.549-1.549v-3.984A1.551,1.551,0,0,0,285.522,341.332Zm0,0",
    transform: "translate(-265.822 -327.166)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2828",
    "data-name": "Path 2828",
    d: "M285.522,0h-6.64a1.551,1.551,0,0,0-1.55,1.549v9.3a1.551,1.551,0,0,0,1.55,1.55h6.64a1.551,1.551,0,0,0,1.549-1.55v-9.3A1.551,1.551,0,0,0,285.522,0Zm0,0",
    transform: "translate(-265.822)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f98397dc1ec0b283e30974e8400ef632.svg";
export { ForwardRef as ReactComponent };